import { connect } from "react-redux";
import { get } from 'lodash';

import ConfirmationTicketList from './ConfirmationTicketList';

const mapStateToProps = state => ({
  ticketList: get(state, 'Event.tickets.results', []),
  tickets: get(state, 'Event.purchaseInformation.tickets', []),
  locale: get(state, 'session.language')
});

export default connect(mapStateToProps)(ConfirmationTicketList);
